import { render, staticRenderFns } from "./OnboardingStepsNoRecurringPayment.vue?vue&type=template&id=69656938&"
import script from "./OnboardingStepsNoRecurringPayment.vue?vue&type=script&lang=js&"
export * from "./OnboardingStepsNoRecurringPayment.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports